import { Dialog, DialogContent, Box, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useConnectionWizard } from '../hooks/useConnectionWizard';
import { useNavigate } from 'react-router-dom';

export const DeviceHealthSuccess = () => {
  const { isOpen, connectionStatus, deviceHealth, close } = useConnectionWizard();
  const navigate = useNavigate();

  const isConnected = connectionStatus === 'connected';

  const handleStartTest = () => {
    close();
    // Navigate to measurement wizard
    navigate('/measurement/new');
  };

  if (!isConnected || !deviceHealth) {
    return null;
  }

  return (
    <Dialog 
      open={isOpen && isConnected} 
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 3,
        }
      }}
    >
      <DialogContent>
        <Box 
          display="flex" 
          flexDirection="column" 
          alignItems="center" 
          textAlign="center"
          gap={2}
        >
          <CheckCircleIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main',
              mb: 1,
            }} 
          />
          
          <Typography variant="h6">
            Device connected successfully
          </Typography>
          
          <Typography variant="body2" color="text.secondary">
            Reader {deviceHealth.serialNumber}
          </Typography>
          
          <Box 
            sx={{ 
              mt: 1, 
              mb: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
            }}
          >
            {/* round battery to nearest integer and show temperature with two decimals */}
            <Typography variant="caption" color="text.secondary">
              Battery: {Math.round(deviceHealth.batteryLevel)}% | Temp: {deviceHealth.temperature.toFixed(2)}°C
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Firmware: v{deviceHealth.firmwareVersion}
            </Typography>
          </Box>
          
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={handleStartTest}
            sx={{ 
              mt: 2,
              height: 48,
              borderRadius: 3,
            }}
          >
            Start test
          </Button>
          
          <Button
            variant="text"
            onClick={close}
            sx={{ mt: 1 }}
          >
            Dismiss
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
